module.exports = __webpack_public_path__ + "static/roche-press-day-2-c36077bee99dc0e30cab0bfc4b31490f.jpg";